module.exports = __webpack_public_path__ + "assets/img/37_1528.e86dc510.jpg";